module.exports = "https://health.dajiuxing.com.cn/img/assets/sharing/reminder.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fsharing%2Freminder.png
// module id = 0fpz
// module chunks = 93